import {getAPIbaseURL} from "@/api/config/init";

const prex = `${getAPIbaseURL()}/api/upload`;

export function uploadCancelamento() {
    return `${prex}`;
}
